module.exports = __webpack_public_path__ + "img/shz.1ccfe754.png";